module.exports = __webpack_public_path__ + "img/profess4.019414bb.png";